module.exports = "/images/quats-bg.jpg?b194b80bf4ba2b79deb1cd5ff696c9aa";